/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/save'
export default icon
